import React, { createContext, useContext, useEffect, useState } from 'react'

const ThemeContext = createContext()

export const ThemeProvider = ({ children }) => {
  // eslint-disable-next-line no-undef
  const [themeMode, setThemeMode] = useState(localStorage.getItem('mode') || 'light')

  useEffect(() => {
    // Keep the document background in sync with the theme so route-level lazy
    // chunks never flash the dark `$main-bg` body background in light theme.
    // eslint-disable-next-line no-undef
    document.body.dataset.theme = themeMode
  }, [themeMode])

  return (
    <ThemeContext.Provider value={{ themeMode, setThemeMode }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => useContext(ThemeContext) || {}
